import { Content, Portal, Viewport } from '@radix-ui/react-select';
import { cva, VariantProps } from 'class-variance-authority';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { FormFieldState } from '@/shared/ui/form/types';
import { SelectScrollDownButton } from './select-scroll-down-button';
import { SelectScrollUpButton } from './select-scroll-up-button';
import './select.scss';

const selectContentVariants = cva('select__content', {
    variants: {
        variant: {
            default: null,
            secondary: 'select__content--secondary',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

type Props = Omit<ComponentPropsWithoutRef<typeof Content>, 'align' | 'position'> &
    VariantProps<typeof selectContentVariants> & {
        state?: FormFieldState;
    };
export const SelectContent = ({ className, children, state, variant, ...props }: Props) => {
    return (
        <Portal>
            <Content
                data-testid="select-content"
                className={cn(
                    selectContentVariants({ variant }),
                    state === 'error' && 'select__content--error',
                    className,
                )}
                position="popper"
                align="center"
                avoidCollisions={false}
                {...props}
            >
                <SelectScrollUpButton />
                <Viewport>{children}</Viewport>
                <SelectScrollDownButton />
            </Content>
        </Portal>
    );
};
